import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import VerifyCheckMaster from "./VerifyCheckMaster";
import { Spinner } from 'reactstrap';
const Home = () => {
    var _a;
    const verifyCheck = useSelector((state) => state.verifyCheck);
    return React.createElement("div", null,
        ((_a = verifyCheck === null || verifyCheck === void 0 ? void 0 : verifyCheck.isLoading) !== null && _a !== void 0 ? _a : null) ? React.createElement(Spinner, { id: "loader", animation: "border" }) : null,
        React.createElement(VerifyCheckMaster, null));
};
export default connect()(Home);
//# sourceMappingURL=Home.js.map